// extracted by mini-css-extract-plugin
export var cardContainer = "_nk-0";
export var cardHeader = "_nk-2";
export var collapsedState = "_nk-3";
export var dragHandle = "_nk-5";
export var dragHandleIcon = "_nk-6";
export var dragging = "_nk-1";
export var titleArea = "_nk-4";